import * as React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { ContentSpacing } from '@estee/elc-base-theme';
import { ITranslationsCollection, translate } from '@estee/elc-service';
import { DiscountPercentOff } from '../../constants/Price';

export interface IProductPriceRangeDiscount {
    className?: string;
    maxDiscountPercent: number;
    translations?: ITranslationsCollection;
}

const ProductPriceRangeDiscountWrapper = styled.span`
    margin: 0 0 0 ${ContentSpacing.space8};

    [dir='rtl'] & {
        margin: 0 ${ContentSpacing.space8} 0 0;
    }
`;

const buildRangeDiscountText = (props: IProductPriceRangeDiscount) => {
    const { maxDiscountPercent, translations } = props;
    const { discountedPriceRangePercentMessage } = translations as ITranslationsCollection;

    return discountedPriceRangePercentMessage.replace(
        DiscountPercentOff.PERCENT,
        maxDiscountPercent
    );
};

export const ProductPriceRangeDiscount = translate(['discountedPriceRangePercentMessage'])(
    observer(function ProductPriceRangeDiscount(props: IProductPriceRangeDiscount) {
        const productPriceRangeDiscountClassNames = classnames(
            'elc-product-price-range-discount',
            'js-product-price-range-discount',
            props.className
        );

        const rangeDiscountMessage = buildRangeDiscountText(props);

        return (
            <ProductPriceRangeDiscountWrapper
                className={productPriceRangeDiscountClassNames}
                dangerouslySetInnerHTML={{ __html: rangeDiscountMessage }}
            />
        );
    })
);
